module.exports = "/headshot_luiz_gabriel_todt_de_azevedo.jpg?c0aac5";